import { Period } from '@heidi/commerce/contracts';
import { Badge } from '@heidi/design-system/badge';
import {
  SegmentedControlList,
  SegmentedControlTrigger,
} from '@heidi/design-system/segmented-control';

import { FormattedMessage } from 'react-intl';

export const PeriodTabsList = () => {
  return (
    <SegmentedControlList className="self-center">
      <SegmentedControlTrigger value={Period.ONE_YEAR} className="gap-x-1">
        <FormattedMessage
          defaultMessage="Yearly"
          id="5E89IlKVoD"
          description="Billing period tab for a yearly subscription"
        />
        <Badge color="green" size="xs">
          <FormattedMessage
            defaultMessage="Save 30%"
            id="woy1jsEaeI"
            description="Badge on the yearly billing tab showing the discount over monthly"
          />
        </Badge>
      </SegmentedControlTrigger>
      <SegmentedControlTrigger value={Period.ONE_MONTH}>
        <FormattedMessage
          defaultMessage="Monthly"
          id="s/vL+3rKCU"
          description="Billing period tab for a monthly subscription"
        />
      </SegmentedControlTrigger>
    </SegmentedControlList>
  );
};
